// ref: ng g c core/layout/messages-layout

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mdwg-messages-layout',
  templateUrl: './messages-layout.component.html',
  styleUrls: ['./messages-layout.component.scss']
})
export class MessagesLayoutComponent implements OnInit {

  msgBackgroundColor: string;
  msgFontColor: string;
  messageText: string;

  constructor() { 
    this.messageText = "Messages go here!";
    this.msgFontColor = "white";
    this.msgBackgroundColor = "black";
    this.warn("User feedback messages go here!");
    this.none();
  }

  ngOnInit(): void {
  }

  setMessageText(message: string) {
    this.messageText = message;
  }

  none() {
    // set background-color black
    // set (font-)color black
    this.msgFontColor = "transparent";
    this.msgBackgroundColor = "transparent";
  }

  info(infoMessage: string) {
    this.setMessageText(infoMessage);
    this.msgFontColor = (infoMessage.length === 1) ? "gray" : "white";
    this.msgBackgroundColor = "gray";
  }

  debug(debugMessage: string) {
    this.setMessageText(debugMessage);
    this.msgFontColor = "green";
  }

  warn(warnMessage: string) {
    this.setMessageText(warnMessage);
    this.msgBackgroundColor = "gray";
    this.msgFontColor = "yellow";
  }

  error(errorMessage: string) {
    this.setMessageText(errorMessage);
    this.msgFontColor = "red";
  }

}
